import classNames from 'classnames';
import type { FC, ReactNode } from 'react';

interface GradientBorderProps {
  children: ReactNode;
  className?: string;
  borderWidth?: number;
  rounded?: string;
}

const AIGradientBorder: FC<GradientBorderProps> = ({
  children,
  className,
  borderWidth = 2,
  rounded = 'lg',
}) => {
  return (
    <div
      className={classNames(
        'relative bg-gradient-to-r from-[rgba(39,142,211,1)] via-[rgba(126,74,222,1)] via-[rgba(222,53,166,1)] to-[rgba(249,115,22,1)] rounded-lg',
        className,
      )}
      style={{ padding: borderWidth }}
    >
      <div className={classNames(`bg-white rounded-${rounded} relative z-10`)}>
        {children}
      </div>
    </div>
  );
};

export default AIGradientBorder;
